module.exports = __webpack_public_path__ + "static/media/15.a4b4e4f0.mp4";